import { render, staticRenderFns } from "./EditBoccoChannelWebhook.vue?vue&type=template&id=a857bd86&scoped=true&"
import script from "./EditBoccoChannelWebhook.vue?vue&type=script&lang=ts&"
export * from "./EditBoccoChannelWebhook.vue?vue&type=script&lang=ts&"
import style0 from "./EditBoccoChannelWebhook.vue?vue&type=style&index=0&id=a857bd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a857bd86",
  null
  
)

export default component.exports